import React, { useState, useEffect } from 'react';
import { Toggle, Button, InlineLoading } from 'carbon-components-react';
import { WebhookConfig } from 'components';
import { WebhookSubscriptionFormProps } from 'types';
import { FormikProps } from 'formik';
import Utils from 'utilities/helper.util';

const WebHookSubscriptionForm: React.FC<Props> = ({
  submitting,
  deleting,
  eventLabel,
  values,
  errors: fErrors,
  touched: fTouched,
  setFieldValue,
  setFieldTouched,
  handleChange,
  handleBlur,
  handleSubmit,
  handleCancel,
  disableDeleted,
  handleDelete,
  apiCalled
}) => {
  const [canSave, setCanSave] = useState<boolean>(false);

  const generateKey = (key: string) => {
    setFieldTouched('clientKey', true);
    setFieldValue('clientKey', key);
  };

  const customHeaderChangeHandler = (e: any) => {
    const key = Object.keys(e)[0];
    const value = Object.values(e)[0];
    setFieldTouched(key, true);
    setFieldValue(key, value);
  };

  const toogleChangeHandler = (pause: boolean) => {
    setFieldTouched('isPaused', true);
    setFieldValue('isPaused', pause);
  };

  useEffect(() => {
    setCanSave(!Utils.isObjectEmpty(fTouched) && Utils.isObjectEmpty(fErrors));
  }, [fErrors, fTouched]);

  return (
    <div className="webhook-subscriptions-event-form-container">
      <div className="form-title">{eventLabel}</div>
      <hr className="section__divider" />
      <div className="form-content">
        <div className="form-api-setting-container">
          <WebhookConfig
            handleChange={handleChange}
            handleBlur={handleBlur}
            values={values}
            errors={fErrors}
            touched={fTouched}
            customHeaderchangeHandler={customHeaderChangeHandler}
            secureKey={values.clientKey}
            generateKeyHandler={generateKey}
          />
        </div>
        <hr className="section__divider" />
        <div className="form-is-pause-toggle-container">
          <div className="form-is-pause-toggle-label">Pause notifications</div>
          <Toggle
            defaultToggled={values.isPaused}
            labelText=""
            id="toggle-update-user-form-search"
            onToggle={(checked: boolean) => toogleChangeHandler(checked)}
          />
        </div>
        <hr className="section__divider" />
        <div className="form-unsubscribe-container">
          <Button
            kind="tertiary"
            size="field"
            disabled={disableDeleted || deleting}
            onClick={handleDelete}
          >
            Unsubscribe
          </Button>
          <div className="form-unsubscribe-helper-text">
            Clear the form details and remove this subscription {apiCalled}
          </div>
        </div>
      </div>
      <div className="form-footer">
        <Button
          id="webhook-subscriptions-event-form-cancel-button"
          name="cancel"
          kind="secondary"
          data-testid="cancel"
          disabled={submitting || deleting}
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          id="webhook-subscriptions-event-form-save-button"
          name="create"
          type="submit"
          kind="primary"
          data-testid="submit"
          disabled={submitting || deleting || !canSave}
          onClick={handleSubmit}
        >
          {!submitting && !apiCalled ? (
            'Save'
          ) : (
            <InlineLoading
              description={!submitting && apiCalled ? 'Saved' : 'Saving ...'}
              status={!submitting && apiCalled ? 'finished' : 'active'}
              aria-live={'assertive'}
            />
          )}
        </Button>
      </div>
    </div>
  );
};

type Props = FormikProps<any> & WebhookSubscriptionFormProps;

WebHookSubscriptionForm.displayName = 'WebHookSubscriptionForm';

export default React.memo(WebHookSubscriptionForm);
